import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import ComponentToPrint from "./ComponentToPrint";
import "./jamb-summary.css";

function SummaryPage() {
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "JAMB Application Summary",
    pageStyle: "@page { size: auto; margin: 12mm; }",
  });

  return (
    <div className="jamb-summary-page">
      <div className="jamb-summary-shell">
        <ComponentToPrint ref={componentRef} />

        <div className="jamb-summary-actions">
          <button
            type="button"
            className="jamb-summary-print-btn"
            onClick={handlePrint}
          >
            Print Summary
          </button>
        </div>
      </div>
    </div>
  );
}

export default SummaryPage;
